module.exports = __webpack_public_path__ + "static/media/background-1.998c3380.jpg";